import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabsbookinginpune() {



    const cardData = {

keyword: "Sedan Cabs Booking in Pune",

headingDescription:
    "Rising Cab Service offers quick, reliable, and affordable Sedan Cabs Booking in Pune for airport transfers, city travel, office commutes, family trips, and outstation journeys. We provide well-maintained sedan cars like Swift Dzire, Etios, and similar models with clean interiors, smooth AC, professional drivers, and fuel-efficient rides. With doorstep pickup across Pune, instant booking options, 24/7 availability, one-way and round-trip services, and transparent pricing, we ensure a safe, comfortable, and budget-friendly travel experience for all passengers.",

topPlaces: [
    {
        title: "Pune Airport to City Travel",
        description:
            "Sedan cabs are widely used for Pune Airport transfers to all major city areas including Viman Nagar, Koregaon Park, Hinjewadi, and Shivajinagar. They offer timely pickup, smooth rides, and affordable comfort for both business and leisure travelers."
    },
    {
        title: "Lonavala & Khandala Weekend Trip",
        description:
            "Lonavala and Khandala are popular weekend destinations near Pune known for waterfalls, valleys, and scenic viewpoints. Sedan cabs are perfect for couples and small families looking for comfortable and budget-friendly hill station travel."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra. Sedan cab booking is ideal for small families planning Sai Baba darshan, offering a smooth and peaceful highway journey from Pune."
    },
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberries, viewpoints, and cool weather. Sedan cabs provide affordable and comfortable travel for small groups exploring scenic attractions and nature spots."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual and cultural destination known for Trimbakeshwar Jyotirlinga and temples. Sedan cabs are a cost-effective option for pilgrimage and leisure trips from Pune with smooth highway travel."
    },
    {
        title: "Pune City Local Travel",
        description:
            "Sedan cabs are widely used for daily city travel in Pune including office commutes, shopping, meetings, and local sightseeing. They offer affordable, clean, and comfortable rides for everyday transportation needs."
    },
    {
        title: "Alibaug Beach Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches and forts. Sedan cabs are ideal for couples and small families planning budget-friendly weekend beach vacations from Pune."
    },
    {
        title: "Bhimashankar Jyotirlinga Visit",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills. Sedan cabs provide a comfortable and economical option for devotees traveling from Pune for spiritual darshan and nature visits."
    },
    {
        title: "Ashtavinayak Darshan Tour",
        description:
            "The Ashtavinayak circuit includes eight sacred Ganpati temples across Maharashtra. Sedan cabs are suitable for small family pilgrimage tours offering comfort and affordability for religious travel."
    },
    {
        title: "Outstation Budget Cab Travel",
        description:
            "Sedan cabs are one of the most popular choices for budget outstation travel from Pune. They provide fuel-efficient, comfortable, and economical rides for short and medium-distance trips across Maharashtra."
    }
],



services: [
{
name: "Sedan Cabs in Pune",
description: "Rising Cab Service offers Sedan Cabs in Pune for comfortable, affordable, and reliable travel across city and outstation routes. Our sedan fleet includes clean AC vehicles like Swift Dzire and Toyota Etios, ideal for family trips, business travel, and daily commuting. We ensure professional drivers, doorstep pickup, 24x7 availability, and transparent pricing with no hidden charges. Whether it is airport transfer, local travel, or long-distance journeys, our sedan cabs provide smooth rides, fuel efficiency, and budget-friendly comfort for all passengers in Pune and nearby areas."
},
{
name: "Best Cab Service in Pune",
description: "Rising Cab Service is recognized as one of the Best Cab Services in Pune, offering safe, reliable, and affordable transportation solutions. We provide a wide range of vehicles including sedans, SUVs, Innova Crysta, Tempo Traveller, and luxury vans. Our service ensures punctual pickups, experienced chauffeurs, clean vehicles, and 24x7 customer support. Whether you need local travel, airport transfers, corporate travel, or outstation trips, we guarantee a smooth, comfortable, and stress-free journey experience."
},
{
name: "Sedan Taxi Near Me in Pune",
description: "Find Sedan Taxi Near Me in Pune with Rising Cab Service for quick and convenient travel anytime. Our nearby sedan taxis are available across Pune for instant booking, ensuring fast pickup and smooth rides. Perfect for local travel, airport transfers, and short outstation trips, our service guarantees clean AC cars, professional drivers, and affordable pricing."
},
{
name: "Sedan Cab Service Near Me in Pune",
description: "Rising Cab Service provides Sedan Cab Service Near Me in Pune for instant and reliable transportation. With easy booking and fast response time, we ensure comfortable AC sedan cars reach your location quickly. Our service is ideal for office travel, shopping trips, airport drops, and family outings with safe and professional drivers."
},
{
name: "Sedan Cab Service for Outstations",
description: "Book Sedan Cab Service for Outstations with Rising Cab Service for safe and economical long-distance travel. Our sedan cabs are perfect for trips to Mumbai, Goa, Shirdi, Nashik, Lonavala, and other destinations. We provide experienced chauffeurs, clean vehicles, and affordable per km pricing for a smooth highway journey."
},
{
name: "Toyota Etios Taxi in Pune",
description: "Rising Cab Service offers Toyota Etios Taxi in Pune for comfortable and budget-friendly travel. The Etios sedan is known for its spacious interiors, smooth ride quality, and fuel efficiency, making it ideal for both city and outstation travel with professional drivers and 24x7 availability."
},
{
name: "Toyota Etios Cab in Pune",
description: "Book Toyota Etios Cab in Pune for safe and reliable transportation at affordable rates. Our Etios cabs are well-maintained, AC-enabled, and driven by experienced chauffeurs ensuring smooth travel for families, corporates, and solo passengers."
},
{
name: "Taxi & Sedan Services Booking",
description: "Rising Cab Service offers Taxi & Sedan Services Booking in Pune for quick and hassle-free travel arrangements. Customers can easily book sedan taxis for local rides, airport transfers, and outstation trips with transparent pricing, instant confirmation, and 24x7 support."
},
{
name: "Sedan Taxi Service for Outstations",
description: "Book Sedan Taxi Service for Outstations with Rising Cab Service for comfortable long-distance travel. We offer reliable sedan cars with professional drivers for journeys across Maharashtra and nearby states, ensuring safety, affordability, and smooth highway travel experience."
},
{
name: "Pune to Nashik Sedan Cab Service",
description: "Rising Cab Service provides Pune to Nashik Sedan Cab Service for comfortable and affordable travel. Our AC sedan cabs ensure smooth highway journeys with experienced drivers, making it ideal for pilgrimage, business trips, and weekend getaways."
},
{
name: "Pune to Goa Cab Service",
description: "Book Pune to Goa Cab Service with Rising Cab Service for a safe and enjoyable beach vacation trip. Our sedan and SUV options ensure comfortable long-distance travel with professional drivers and flexible pickup options."
},
{
name: "Pune to Mumbai Cab Services",
description: "Rising Cab Service offers Pune to Mumbai Cab Services for fast, reliable, and comfortable intercity travel. Enjoy door-to-door pickup, experienced chauffeurs, and smooth highway rides suitable for business and personal travel."
},
{
name: "Pune to Lonavala Sedan Cab",
description: "Book Pune to Lonavala Sedan Cab for a quick hill station getaway. Our AC sedan cabs ensure smooth travel via expressways with affordable pricing and professional drivers, perfect for family and weekend trips."
},
{
name: "Outstation Sedan Cab Service",
description: "Rising Cab Service provides Outstation Sedan Cab Service for long-distance travel across Maharashtra and nearby states. Enjoy clean vehicles, experienced drivers, and budget-friendly pricing for safe and comfortable journeys."
},
{
name: "Sedan Cabs for Corporate Outstation",
description: "Book Sedan Cabs for Corporate Outstation travel with Rising Cab Service for business meetings, employee travel, and official trips. We ensure punctual service, professional chauffeurs, and comfortable AC sedan vehicles for corporate clients."
},
{
name: "Pune to Shirdi Sedan Cabs",
description: "Rising Cab Service offers Pune to Shirdi Sedan Cabs for a peaceful and spiritual journey to Sai Baba’s holy shrine. Our service includes safe highway travel, clean AC cars, and experienced drivers for a comfortable pilgrimage experience."
},
{
name: "Pune to Aurangabad Sedan Taxi",
description: "Book Pune to Aurangabad Sedan Taxi for reliable and comfortable outstation travel. Our sedan cabs ensure smooth highway journeys with professional drivers and affordable pricing for family and business trips."
},
{
name: "Sedan Taxi in Pune",
description: "Rising Cab Service provides Sedan Taxi in Pune for local and outstation travel with clean AC cars, experienced drivers, and 24x7 availability ensuring safe and comfortable rides."
},
{
name: "Sedan Car on Rent Pune",
description: "Book Sedan Car on Rent in Pune for flexible travel solutions including hourly, daily, and outstation packages. Our service ensures affordable pricing, professional drivers, and comfortable rides."
},
{
name: "Sedan Cab Rental Pune",
description: "Rising Cab Service offers Sedan Cab Rental in Pune for city travel, airport transfers, and long-distance journeys with well-maintained cars and reliable chauffeur service."
},
{
name: "Pune Sedan Taxi Service",
description: "Book Pune Sedan Taxi Service with Rising Cab Service for safe, affordable, and comfortable travel across Pune and nearby destinations. We ensure punctual service and clean vehicles."
},
{
name: "Sedan Cab for Outstation Pune",
description: "Rising Cab Service provides Sedan Cab for Outstation from Pune for long-distance travel with experienced drivers, AC comfort, and budget-friendly pricing for all major routes."
}
],

tableData: [
["Sedan Cabs in Pune","Best Cab Service in Pune"],
["Sedan Taxi Near Me in Pune","Sedan Cab Service Near Me in Pune"],
["Sedan Cab Service for Outstations","Toyota Etios Taxi in Pune"],
["Toyota Etios Cab in Pune","Taxi & Sedan Services Booking"],
["Sedan Taxi Service for Outstations","Pune to Nashik Sedan Cab Service"],
["Pune to Goa Cab Service","Pune to Mumbai Cab Services"],
["Pune to Lonavala Sedan Cab","Outstation Sedan Cab Service"],
["Sedan Cabs for Corporate Outstation","Pune to Shirdi Sedan Cabs"],
["Pune to Aurangabad Sedan Taxi","Sedan Taxi in Pune"],
["Sedan Car on Rent Pune","Sedan Cab Rental Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Professional Sedan Cabs Booking in Pune",
        WhyChoosedescription: "Rising Cab Service offers reliable sedan cab booking solutions for daily travel, business meetings, airport transfers, family outings, and outstation journeys."
    },
    {
        WhyChooseheading: "Comfortable Travel for Every Occasion",
        WhyChoosedescription: "Our sedan cabs provide smooth rides, comfortable seating, air-conditioned cabins, and a pleasant travel experience for all passengers."
    },
    {
        WhyChooseheading: "Best Choice for Corporate Transportation",
        WhyChoosedescription: "Sedan cabs are widely preferred by professionals for office commutes, client meetings, employee transportation, and corporate travel requirements."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Book sedan cabs for Pune city travel or outstation destinations such as Mumbai, Nashik, Shirdi, Mahabaleshwar, Lonavala, Kolhapur, and Goa."
    },
    {
        WhyChooseheading: "Well-Maintained Fleet of Sedan Cars",
        WhyChoosedescription: "Choose from Swift Dzire, Hyundai Aura, Honda Amaze, Toyota Etios, and other premium sedan vehicles maintained for maximum comfort and safety."
    },
    {
        WhyChooseheading: "Quick Pickup Across Pune and PCMC",
        WhyChoosedescription: "We provide doorstep pickup services from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Safe Journeys",
        WhyChoosedescription: "Our courteous and professional drivers ensure timely arrivals, safe driving practices, and a hassle-free travel experience."
    },
    {
        WhyChooseheading: "Easy Booking with Flexible Travel Plans",
        WhyChoosedescription: "Customers can book one-way rides, round trips, airport transfers, full-day rentals, and customized travel packages as per their needs."
    }
]
};

const faqData = [
    {
        question: "What types of sedan cars are available for booking in Pune?",
        answer: "We offer popular sedan vehicles including Swift Dzire, Hyundai Aura, Honda Amaze, Toyota Etios, and similar comfortable cars."
    },
    {
        question: "Can I book a sedan cab for outstation travel?",
        answer: "Yes, sedan cabs are available for outstation destinations across Maharashtra and neighboring states."
    },
    {
        question: "Are sedan cabs suitable for airport transfers?",
        answer: "Yes, sedan vehicles are ideal for Pune Airport and Mumbai Airport pickup and drop services."
    },
    {
        question: "Can I book a sedan cab for corporate travel?",
        answer: "Yes, we provide sedan cabs for business meetings, office travel, client visits, and executive transportation."
    },
    {
        question: "Do you offer one-way sedan cab services?",
        answer: "Yes, both one-way and round-trip sedan cab bookings are available."
    },
    {
        question: "Is advance booking available for sedan cabs?",
        answer: "Yes, customers can pre-book sedan cabs for planned travel and airport transfers."
    },
    {
        question: "Are the sedan cars air-conditioned?",
        answer: "Yes, all our sedan vehicles are equipped with air conditioning for a comfortable journey."
    },
    {
        question: "Can families use sedan cabs for sightseeing trips?",
        answer: "Yes, sedan cabs are suitable for small families visiting tourist destinations and weekend getaway locations."
    },
    {
        question: "Do you provide pickup services from hotels and railway stations?",
        answer: "Yes, pickup services are available from hotels, Pune Railway Station, Pune Airport, offices, and residential addresses."
    },
    {
        question: "How can I book a sedan cab in Pune?",
        answer: "You can book through phone calls, WhatsApp, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Tejas Ghadge",
        feedback:
            "I regularly book sedan cabs for business meetings in Pune. The service is always punctual, the cars are clean, and the drivers are professional.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Anuja Bhosale",
        feedback:
            "We booked a sedan cab for a family trip to Lonavala. The vehicle was comfortable, well-maintained, and the journey was smooth throughout.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Sedan Cabs Booking in Pune",
"image": "https://www.risingcabservice.com/assets/images/sedan-cab-pune.jpg",
"description": "Book Sedan Cabs in Pune with Rising Cab Service for affordable local and outstation travel. Ideal for airport transfers, corporate trips, and tours to Mumbai, Goa, Nashik, Lonavala, Shirdi, and Aurangabad.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/sedan-cabs-booking-in-pune"
}
};



    return (
        <div>
<Helmet>
  <title>Sedan Cabs Booking in Pune | Affordable Outstation Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Sedan Cabs in Pune for affordable local and outstation travel. Ideal for airport transfers, corporate trips, and tours to Mumbai, Goa, Nashik, Lonavala, Shirdi, and more."
/>

<meta
 name="keywords"
 content="sedan cabs in pune, sedan taxi near me pune, sedan cab service pune, toyota etios taxi pune, toyota etios cab pune, sedan taxi for outstation, pune to mumbai sedan cab, pune to goa sedan cab, pune to shirdi sedan cab, pune to lonavala sedan cab, outstation sedan cab pune, sedan car on rent pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sedancabsbookinginpune;